import { render, staticRenderFns } from "./IsvPayIfConfigList.vue?vue&type=template&id=f90a525e&scoped=true"
import script from "./IsvPayIfConfigList.vue?vue&type=script&lang=js"
export * from "./IsvPayIfConfigList.vue?vue&type=script&lang=js"
import style0 from "./IsvPayIfConfigList.vue?vue&type=style&index=0&id=f90a525e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90a525e",
  null
  
)

export default component.exports